<script setup lang="ts">
import {RefreshCcw04} from "utruckin-icons";
import CommonButton from "@/components/common/CommonButton.vue";
import {useRouter} from "vue-router";

const router = useRouter();

const goBack = () => {
  router.go(-1);
}

const goHome = () => {
  router.push("/");
}
</script>

<template>
  <div class="v-error">
    <div class="main">
      <div class="main__content">
        401
      </div>

      <div class="main__headline">
        You’re not authorized
      </div>

      <div class="main__description">
        You’re logged in, but you don’t have access to this resource. If you believe this is a mistake, contact support
        or your administrator.
      </div>

      <div class="main__action">
        <CommonButton @click="goBack" type="outline" prepend :prepend-icon="RefreshCcw04"
                      label="Refresh"></CommonButton>
        <CommonButton @click="goHome" type="primary" label="Go to home"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>